/*
 * Header behavior: mobile menu drawer (native <dialog>) and desktop dropdowns (<details>).
 * Uses event delegation so it keeps working after the Theme Editor re-renders sections.
 * Native <dialog>.showModal() provides the focus trap, Escape handling, inert background,
 * and focus return to the opening button.
 */
(() => {
  const DESKTOP_QUERY = window.matchMedia('(min-width: 1024px)');

  const openDropdowns = () => document.querySelectorAll('[data-nav-dropdown][open]');

  const closeDropdowns = (except) => {
    openDropdowns().forEach((dropdown) => {
      if (dropdown !== except) dropdown.open = false;
    });
  };

  const setExpanded = (dialog, expanded) => {
    document
      .querySelectorAll(`[data-drawer-open][aria-controls="${dialog.id}"]`)
      .forEach((button) => button.setAttribute('aria-expanded', String(expanded)));
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (dialog && !dialog.open) {
        dialog.showModal();
        setExpanded(dialog, true);
      }
      return;
    }

    const closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }

    // A click on the dialog element itself is a click on its backdrop.
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('menu-drawer')) {
      event.target.close();
      return;
    }

    if (!event.target.closest('[data-nav-dropdown]')) closeDropdowns();
  });

  // 'close' and 'toggle' do not bubble; listen in the capture phase.
  document.addEventListener(
    'close',
    (event) => {
      if (event.target instanceof HTMLDialogElement) setExpanded(event.target, false);
    },
    true
  );

  document.addEventListener(
    'toggle',
    (event) => {
      if (event.target.matches?.('[data-nav-dropdown]') && event.target.open) closeDropdowns(event.target);
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('[data-nav-dropdown][open]');
    if (open) {
      open.open = false;
      open.querySelector('summary')?.focus();
    }
  });

  document.addEventListener('focusout', (event) => {
    const dropdown = event.target.closest?.('[data-nav-dropdown][open]');
    if (dropdown && !dropdown.contains(event.relatedTarget)) dropdown.open = false;
  });

  // If the viewport grows to desktop while the drawer is open, close it.
  DESKTOP_QUERY.addEventListener('change', (event) => {
    if (!event.matches) return;
    document.querySelectorAll('dialog.menu-drawer[open]').forEach((dialog) => dialog.close());
  });
})();
